import getCSSVariableValue from './getCSSVariableValue';

export {
    getCSSVariableValue
};

window.issueTypology = {
    '1': 'Collective No service',
    '5': 'Individual No service'
};